/* RESPONSIBLE TEAM: team-reporting */

import Highcharts from 'highcharts/esm/highcharts.src.js';

const theme: Highcharts.Options = {
  chart: {
    backgroundColor: 'transparent',
    style: {
      fontFamily: 'inherit',
      fontSize: '16px',
    },
  },
  xAxis: {
    lineColor: 'var(--neutral-border)',
    labels: {
      style: {
        color: 'var(--text-muted)',
        fontSize: '12px',
      },
    },
  },
  yAxis: {
    gridLineColor: 'var(--neutral-border)',
    labels: {
      style: {
        color: 'var(--text-muted)',
        fontSize: '12px',
      },
    },
  },
  colorAxis: {
    labels: {
      style: {
        color: 'var(--text-muted)',
        fontSize: '12px',
      },
    },
  },
  legend: {
    itemStyle: {
      color: 'var(--text-muted)',
      fontSize: '12px',
      fontWeight: 'normal',
    },
    itemHoverStyle: {
      color: 'var(--text-default)',
    },
  },
  tooltip: {
    borderWidth: 1,
  },
  plotOptions: {
    series: {
      borderRadius: 0,
    } as Highcharts.PlotSeriesOptions,
    area: { lineWidth: 1.7 },
    line: { lineWidth: 1.7 },
  },
  title: undefined,
  credits: { enabled: false },
};

Highcharts.setOptions(theme);
